import React, { useState } from 'react';
import _ from 'lodash';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

// constants
import LocalStrings from '../../assets/languages';
import countryList from '../../constants/CountryCode';
import { LABEL_POSITION_LEFT } from '../../constants/constant';

export default function PhoneInput(field) {
  const { meta, labelPosition, label } = field;

  const parts =
    !_.isNull(field?.input?.value) && typeof field?.input?.value === 'string'
      ? field?.input?.value.split(' ')
      : '';
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCode, setSelectedCode] = useState(parts[0]);
  const [phoneNumber, setPhoneNumber] = useState(parts[1]);

  let divClassName = `form-group row mx-0 mb-0${
    meta.touched && meta.error ? ' has-danger' : ''
  }`;
  let labelClasses = 'control-label-top col-sm-12 p-0';
  let inputClasses = 'col-sm-12 col-sm-offset-0 px-0';

  if (labelPosition === LABEL_POSITION_LEFT) {
    labelClasses = 'control-label col-xs-12 col-sm-12 col-md-3';
    inputClasses = 'col-xs-12 col-sm-12 col-md-9 col-sm-offset-0';
  }

  const handlePhoneNumberInput = (inputValue, formatData) => {
    setPhoneNumber(inputValue);
    const returnValue =
      !_.isEmpty(inputValue) && !_.isEmpty(formatData?.dialCode)
        ? `${formatData?.dialCode} ${inputValue}`
        : '';
    field?.input?.onChange(returnValue);
  };

  // Filter country list

  const filteredCountryList = _.filter(countryList, list => {
    const term = searchTerm.toLowerCase();
    return (
      list?.name?.toLocaleLowerCase().includes(term) ||
      list?.dial_code?.toLowerCase().includes(term)
    );
  });

  return (
    <div className={divClassName}>
      {label !== '' ? (
        <label className={labelClasses}>
          {label}
          <span className="label-mandatory">
            {field.mandatory === 'true' ? '*' : ''}
          </span>
        </label>
      ) : null}

      <div className={inputClasses}>
        {field?.disabled ? (
          <span className="form-control input-field disabled cursor-not-allowed">
            {field?.input?.value}
          </span>
        ) : (
          <div className="position-relative">
            <div className="containers">
              <div className="input-group">
                <UncontrolledDropdown direction="right">
                  <DropdownToggle
                    className="form-control"
                    style={{
                      borderRadius: '5px 0 0 5px'
                    }}
                    caret
                  >
                    {selectedCode}
                  </DropdownToggle>
                  <DropdownMenu
                    className="scrollbar-hide-no-maxheight"
                    style={{
                      maxHeight: '300px',
                      width: '350px',
                      paddingTop: '0',
                      background: 'off-white'
                    }}
                  >
                    <div
                      className="bg-white"
                      style={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        padding: '10px',
                        borderBottom: '1px solid #ccc'
                      }}
                    >
                      <input
                        type="text"
                        placeholder={LocalStrings.dynamic.kSearchText}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        className="form-control bg-offWhite"
                        style={{
                          width: '100%',
                          padding: '5px',
                          boxSizing: 'border-box'

                          // color: `var(--theme-dark-font-primary)`
                        }}
                      />
                    </div>
                    {_.map(filteredCountryList, (list, index) => (
                      <div key={index}>
                        <DropdownItem
                          onClick={() => {
                            setSelectedCode(list?.dial_code);
                            setSearchTerm('');
                          }}
                        >
                          {list?.emoji} {list?.dial_code} {list?.name}
                        </DropdownItem>
                        <DropdownItem divider />
                      </div>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>

                <input
                  type="number"
                  className="form-control "
                  id="phone"
                  placeholder={LocalStrings.dynamic.kPhoneNumber}
                  value={phoneNumber}
                  onChange={e =>
                    handlePhoneNumberInput(e.target.value, {
                      dialCode: selectedCode
                    })
                  }
                />
              </div>
            </div>
          </div>
        )}

        <div className="text-help">{meta.touched ? meta.error : ''}</div>

        {field.maxlength && !field?.disabled ? (
          <span className="char-left">
            {`${field.input.value.length}/${field.maxlength}`}
          </span>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
